import { render, staticRenderFns } from "./CarbonCopyModal.vue?vue&type=template&id=2f9d3f5c&"
import script from "./CarbonCopyModal.vue?vue&type=script&lang=js&"
export * from "./CarbonCopyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports